interface Orb {
  id: number;
  size: number;
  x: string;
  y: string;
  color: string;
  duration: number;
}

const orbs: Orb[] = [
  { id: 1, size: 600, x: "10%", y: "20%", color: "280 100% 70%", duration: 20 },
  { id: 2, size: 500, x: "80%", y: "10%", color: "200 100% 70%", duration: 25 },
  { id: 3, size: 400, x: "70%", y: "70%", color: "160 100% 60%", duration: 22 },
  { id: 4, size: 350, x: "20%", y: "80%", color: "50 100% 65%", duration: 18 },
];

export function AnimatedOrbs() {
  return (
    <div className="fixed inset-0 -z-20 overflow-hidden pointer-events-none hidden-on-ios">
      {orbs.map((orb) => (
        <div
          key={orb.id}
          className="absolute rounded-full animate-orb-float"
          style={{
            width: orb.size,
            height: orb.size,
            left: orb.x,
            top: orb.y,
            background: `radial-gradient(circle, hsl(${orb.color} / 0.10) 0%, transparent 70%)`,
            filter: "blur(80px)",
            animationDuration: `${orb.duration}s`,
            animationDelay: `${orb.id * -5}s`,
            willChange: "transform",
          }}
        />
      ))}
    </div>
  );
}
